import type { Router } from 'vue-router';
import type { AlertButtonResult } from '@flash-global66/g-dialog-alert';

type onButtonAlertCloseTransactionType = AlertButtonResult & {
  router: Router;
};

export function onButtonAlertCloseTransaction({
  isPrimary,
  isSecondary,
  router,
}: onButtonAlertCloseTransactionType): void {
  if (isPrimary) return;

  if (isSecondary) {
    router.push({ name: 'movements' });
    return;
  }
}